import * as Yup from 'yup';
import { compareSemverVersions } from '../lib/compareSemverVersions';
import { SEMVER_REGEX } from './system';



export const targetValidation = Yup.lazy((values) => {
  return Yup.object().shape({
    min_version: Yup.string()
      .nullable()
      .matches(SEMVER_REGEX, 'Min version has incorrect format. Try semantic version like 1.0 or 1.0.0')
      .test(
        'check-min-version',
        'Min version should be less than or equal to the max version',
        (value) => {
          const maxValue = values.max_version;

          if (value && maxValue) {
            return compareSemverVersions(value, maxValue) || value === maxValue;
          }

          return true;
        },
      ),
    max_version: Yup.string()
      .nullable()
      .matches(SEMVER_REGEX, 'Max version has incorrect format. Try semantic version like 1.0 or 1.0.0')
      .test(
        'check-max-version',
        'Max version should be greater than or equal to the min version',
        (value) => {
          const minValue = values.min_version;

          if (value && minValue) {
            return compareSemverVersions(minValue, value) || value === minValue;
          }

          return true;
        },
      ),
    platform: Yup.array().of(Yup.string()).min(1, 'Enter at least 1 target platform').required('Target platform is required'),
    countries: Yup.array().of(Yup.string()).min(1, 'Enter at least 1 target country').required('Target countries is required'),
  });
});
